"use strict";
var Observable_1 = require('../../Observable');
var takeLast_1 = require('../../operator/takeLast');
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/~/rxjs/add/operator/takeLast.js
// module id = ../../../../rxjs/add/operator/takeLast.js
// module chunks = 27